//
import Vue from "vue"
import Vuetify, { VSnackbar, VBtn, VIcon } from "vuetify/lib"
import "vuetify/src/stylus/app.styl"
import VuetifyToast from "vuetify-toast-snackbar"

//
import colors from "@/mixins/Colors"

//
Vue.use(Vuetify, {
    iconfont: "md",
    components: { VSnackbar, VBtn, VIcon },
    theme: {
        primary: colors.primaryHTML,
        secondary: colors.secondaryHTML,
        accent: colors.complementHTML,
        error: colors.dangerHTML,
        warning: colors.warningHTML,
        info: colors.infoHTML,
        success: colors.successHTML,
    },
})


Vue.use(VuetifyToast, {
    x       : "center",
	icon    : "info",
	classes : [ "mb-4" ],
    property: "$toast",
    shorts: {
        confirm: {
            classes : [ "confirm mb-4" ],
            color: "accent",
            icon: "warning",
            multiLine: true,
            timeout: 300000,
        },
        error: {
            classes: [ 'white-space-pre mb-4' ], 
            color: "error",
            icon: "error",
            multiLine: true,
        },
        success: {
            icon: "done",
            color: "success",
        },
    },
})
